import React from 'react';
import CincoSegredosPage from './components/CincoSegredosPage';

function CincoSegredos() {
  return <CincoSegredosPage />;
}

export default CincoSegredos;
